import { getDrupalMenu } from '@lucid/utils';
import { graphql, useStaticQuery } from 'gatsby';
import { type I18n } from 'types/types';

export const useMenuTopNavigation = (languageKey: I18n.AvailableLanguagesKey) =>
  getDrupalMenu(
    useStaticQuery(
      graphql`
        {
          drupal {
            menuLinkContentQuery(
              limit: 10000
              sort: [{ field: "parent", direction: ASC }, { field: "weight", direction: ASC }]
              filter: { conditions: [{ field: "bundle", value: "top-navigation", operator: EQUAL }] }
            ) {
              entities {
                ...useMenuHook
              }
            }
          }
        }
      `,
    ),
    languageKey,
  );

export const query = graphql`
  fragment useMenuTopNavigation on Drupal_MenuLinkContentTopNavigation {
    isEnabled: enabled
    description
    fieldProductLink
    fieldDisableLanguage
    fieldBeaconElementDetail
    fieldIsExternalSourceLink
    fieldIsExternalSourceLinkTi
    fieldDropdownTitle
    fieldDropdownDescription
    fieldCustomColumnLength
    fieldViewMore {
      url {
        ...getLinkPath
      }
    }
    fieldDropdownFeaturedItem {
      entity {
        entityTranslations {
          ... on Drupal_ParagraphMenuFeaturedItem {
            langcode {
              value
            }
            fieldAlt
            fieldImage
            fieldTitle
            fieldSubtitle
            fieldResourceLink {
              url {
                ...getLinkPath
              }
            }
          }
        }
      }
    }
  }
`;
